
import { useState, useEffect } from 'react'
import axios from 'axios'

import CoverflowCarousel from './CoverflowCarousel'
import ProductCard from './ProductCard'
import CookieConsent from './CookieConsent'

import { Container, Row, Col, Navbar, Nav, Button, Card, Form, Carousel, Image, Modal, Spinner } from 'react-bootstrap'
import { Phone, ArrowRight, Mail, MapPin, PhoneCall, ChevronLeft, ChevronRight, CircleDot, Eye } from 'lucide-react'

import { PRODUCTS } from './productos'
import Marquee from "react-fast-marquee"

import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'

import eftwm from './img/eftwm.png'
import bm from './img/bm.png'
import repse from './img/repse.jpg'
import activities from './img/activities.jpg'
import mantenimiento from './img/mantenimiento.jpg'
import frase from './img/frase.jpg'
import e01 from './img/services/estudios-de-la-calidad-de-la-energia.jpg'
import e02 from './img/services/estudios-de-puesta-a-tierra-y-pararrayos.jpg'
import e03 from './img/services/estudios-para-ahorro-de-energia.jpg'
import e04 from './img/services/estudios-termograficos.jpg'
import e05 from './img/services/mantenimiento-a-banco-de-capacitores-filtro-de-armonicos.jpg'
import e06 from './img/services/mantenimiento-a-plantas-de-emergencia.jpg'
import e07 from './img/services/mantenimiento-a-subestacion-en-aire-sf-6-vacio.jpg'
import e08 from './img/services/mantenimiento-a-transformadores-en-alta-media-y -baja-tension.jpg'
import e09 from './img/services/pruebas-electricas.jpg'

import argos from './img/prov/argos.png'
import arteche from './img/prov/arteche.png'
import condumex from './img/prov/condumex.png'
import continental from './img/prov/continental.png'
import cross from './img/prov/cross.png'
import eaton from './img/prov/eaton.png'
import schneider from './img/prov/schneider.png'

import aeropuertos from './img/clientes/aeropuertos.png'
import bio from './img/clientes/bio.png'
import cdmx from './img/clientes/cdmx.png'
import cfe from './img/clientes/cfe.png'
import home from './img/clientes/home.png'
import inmax from './img/clientes/inmax.png'
import mercedes from './img/clientes/mercedes.png'
import metelix from './img/clientes/metelix.png'
import neutratec from './img/clientes/neutratec.png'
import phc from './img/clientes/phc.png'
import sacmex from './img/clientes/sacmex.png'
import ProductDetailModal from './ProductDetailModal'

const API_PATH = "https://somosglotones.com/srv/api/euk/sendElectricityMail";
const SITE_KEY = "6LcHanAsAAAAAIA82vvu-8K8z_1IMCOmqg_nliMw";

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [index, setIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [comments, setComments] = useState("")

  const [showMessage, setShowMessage] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [textBtn, setTextBtn] = useState('ENVIAR')

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailProduct, setDetailProduct] = useState(null);

  const [activeCat, setActiveCat] = useState('accesorios')

  useEffect(() => {
    const handleScroll = () => {
      // Si el scroll es mayor a 50px, cambiamos el estado
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {

    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    }

    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
      console.log("Script loaded!");
    });
  }, []);

  const handleOpenModal = (service) => {
    setSelectedService(service);
    setShowModal(true);
  };

  const handleOnClick = (e) => {
    e.preventDefault();
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
        handleOnSubmit(token);
      });
    });
  }

  const handleCloseMessage = () => setShowMessage(false);

  const handleOnSubmit = (token) => {
    var form = document.getElementById('contactForm');
    var data = new FormData(form);
    data.append('recaptcha_response', token);

    setTextBtn("Enviando...")
    setIsActive(true)

    axios.post(API_PATH, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(function (response) {

      if (response.data === "FAIL" || response.data === "ERROR") {
        setTextBtn("ENVIAR")
        setIsActive(false)

        setTitle("Error")
        setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
        setShowMessage(true)
      } else {
        setTextBtn("ENVIAR")
        setIsActive(false)

        setTitle("Mensaje enviado")
        setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
        setShowMessage(true)

        setName("");
        setPhone("");
        setEmail("");
        setComments("");
      }

    }).catch(function (err) {
      setTextBtn("ENVIAR")
      setIsActive(false)

      setTitle("Error")
      setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
      setShowMessage(true)
    });
  }

  const logos = [
    { name: "Argos", url: argos },
    { name: "Arteche", url: arteche },
    { name: "Condumex", url: condumex },
    { name: "Continental", url: continental },
    { name: "Cross", url: cross },
    { name: "EATON", url: eaton },
    { name: "Schneider", url: schneider }
  ];

  const clientes = [
    { name: "Aeropuertos y servicios auxiliares", url: aeropuertos },
    { name: "Argos", url: argos },
    { name: "Bio-Tramex", url: bio },
    { name: "CDMX", url: cdmx },
    { name: "CFE", url: cfe },
    { name: "The Home Depot", url: home },
    { name: "InMax", url: inmax },
    { name: "Mercedes Benz", url: mercedes },
    { name: "Metelix", url: metelix },
    { name: "Neutratec", url: neutratec },
    { name: "PHC", url: phc },
    { name: "Sacmex", url: sacmex }
  ];

  const services = [
    {
      title: "ESTUDIOS", img: e01, subService: [
        {
          title: 'Estudios de la calidad de la energía',
          img: e01,
          description: "Análisis, diagnóstico y soluciones para la calidad de la energía eléctrica.",
          list: ['Análisis de disturbios eléctricos', 'Distorsión armónica', 'Parámetros eléctricos', 'Factor de potencia', 'Código red']
        },
        {
          title: 'Estudios de puesta a tierra y pararrayos',
          img: e02,
          description: "Análisis, diagnóstico y soluciones para la calidad de la energía eléctrica.",
          list: ['Evaluación de la resistividad del terreno', 'Estudio de cobertura de pararrayos', 'Diseño, calculo e instalación', 'Resistencia de malla a tierra', 'Mantenimiento a pararrayos y sistemas de puesta a tierra']
        },
        /*{
          title: 'Estudios para ahorro de energía',
          img: e03,
          description: "Análisis, diagnóstico y soluciones para la calidad de la energía eléctrica.",
          list: ['Diagnostico general de instalaciones eléctricas', 'Análisis de la carga y el sistema', 'Mejorar la eficiencia del sistema', 'Eliminar armónicos, sobretensiones y transitorios de la red eléctrica', 'Evitar fluctuaciones en el voltaje']
        },*/
        {
          title: 'Estudios Termográficos',
          img: e04,
          description: "Análisis, diagnóstico y soluciones para la calidad de la energía eléctrica.",
          list: ['Análisis y evaluación de puntos calientes', 'Corrección de falsos contactos  con base al diagnostico del estudio termográfico', 'Detección de fallas por sobrecalentamiento']
        }
      ]
    },
    {
      title: "MANTENIMIENTO", img: mantenimiento, subService: [
        {
          title: 'Mantenimiento a transformadores en Alta, Media y Baja Tensión',
          img: e08,
          description: "Análisis, diagnóstico y soluciones para la calidad de la energía eléctrica.",
          list: ['Filtrado y desgasificado de aceite dieléctrico', 'Cambio de empaques en boquillas', 'Pruebas al aceite dieléctrico en laboratorio con certificación (EMA)', 'Pruebas eléctricas', 'Reparaciones en campo y cambio de accesorios']
        },
        {
          title: 'Mantenimiento a Subestaciones en aire, SF-6, Vacío',
          img: e07,
          description: "Análisis, diagnóstico y soluciones para la calidad de la energía eléctrica.",
          list: ['Montaje de seccionadores', 'Reparación y/o mantenimiento mayor', 'Pruebas eléctricas', 'Elaboración de terminales', 'Gestoría ante CFE para libranza en media tensión']
        },
        {
          title: 'Pruebas Eléctricas',
          img: e09,
          description: "Análisis, diagnóstico y soluciones para la calidad de la energía eléctrica.",
          list: ['Resistencia de Aislamiento', 'Relación de Transformación', 'Resistencia Óhmica', 'Factor de Potencia', 'Pruebas de VLF', 'Corriente de excitación']
        },
        {
          title: 'Mantenimiento a Banco de capacitores, filtro de armónicos',
          img: e05,
          description: "Análisis, diagnóstico y soluciones para la calidad de la energía eléctrica.",
          list: ['Programación de relevador de protección', 'Valoración, diagnostico y sustitución de componentes dañados', 'Medición de capacitancia total del equipo', 'Prueba a TC´s de control']
        },
        {
          title: 'Mantenimiento a Plantas de emergencia',
          img: e06,
          description: "Análisis, diagnóstico y soluciones para la calidad de la energía eléctrica.",
          list: ['Cambio de aceite', 'Cambio de anticongelante', 'Reparación y/o cambio de resistencias calefactoras', 'Limpieza de inyectores de combustible', 'Rectificación de tensión otorgada por el equipo', 'Pruebas eléctricas', 'Transferencias y unidades de control']
        }
      ]
    }
  ]

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const handleDetailModal = (producto) => {
    setShowDetailModal(true)
    setDetailProduct(producto)
  }

  const onHideDetailModal = () => {
    setShowDetailModal(false)
    setDetailProduct(null)
  }

  const groupItems = (items, groupSize) => {
    return items.reduce((acc, val, i) => {
      const idx = Math.floor(i / groupSize);
      if (!acc[idx]) acc[idx] = [];
      acc[idx].push(val);
      return acc;
    }, []);
  };

  const groupedServices = groupItems(services, 3);

  return (
    <div>

      {detailProduct &&
        <ProductDetailModal show={showDetailModal} onHide={onHideDetailModal} product={detailProduct} />
      }

      <Modal show={showMessage} onHide={handleCloseMessage}>
        <Modal.Header style={{ background: "#fff" }} closeButton>
          <Modal.Title style={{ color: "#000" }}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", background: "#fff" }}>{message}</Modal.Body>
        <Modal.Footer style={{ color: "#000", background: "#fff" }}>
          <Button variant="secondary" onClick={handleCloseMessage}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      {selectedService &&
        <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered
          className="rounded-0"
          contentClassName="border-0 bg-transparent"
          dialogClassName="modal-90w">
          <Modal.Header closeButton className="border-0 bg-transparent">
          </Modal.Header>
          <Modal.Body className="p-4 pt-0">
            <div className="text-center">
              <div className="custom-title-bg">
                <h2 className="text-uppercase">{selectedService.title}</h2>
              </div>
            </div>
            <br />

            <CoverflowCarousel service={selectedService.subService} />
            {/*selectedService.subService.map((item, index) => (
              <Container>
                <Row>
                  <h6 className="fw-bold mb-3 text-uppercase modal-service-subTitle" style={{ color: '#1b337e', letterSpacing: '1px' }}>
                    {item.title}
                  </h6>
                </Row>

                <Row key={index} className={`mb-5 align-items-center modal-service-container ${index % 2 !== 0 ? 'flex-row-reverse' : ''}`}>

                  <Col md={6} className="mb-3 mb-md-0">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="img-fluid w-100"
                      style={{
                        borderTopRightRadius: index % 2 !== 0 ? '0' : '40px',
                        borderTopLeftRadius: index % 2 !== 0 ? '40px' : '0',
                        height: '300px',
                        objectFit: 'cover'
                      }}
                    />
                  </Col>

                  <Col md={6} className='modal-service-desc'>
                    <p className="mb-4">{item.description}</p>

                    <h6 className="fw-bold mb-3 text-uppercase" style={{ letterSpacing: '1px' }}>
                      Actividades principales:
                    </h6>

                    <ListGroup variant="flush">
                      {item.list.map((task, i) => (
                        <ListGroup.Item key={i} className="border-0 px-0 d-flex align-items-start bg-transparent">
                          <CheckCircle2
                            size={18}
                            className="me-2 mt-1 flex-shrink-0"
                            color="#1b337e"
                          />
                          <span>{task}</span>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </Col>
                </Row>
              </Container>
            ))*/}
          </Modal.Body>
        </Modal>
      }

      <Navbar
        expand="lg"
        fixed="top"
        className={`custom-navbar ${scrolled ? 'navbar-scrolled' : 'navbar-transparent'}`}
      >
        <Container fluid className="px-lg-5">
          <Navbar.Brand href="#home" className="fw-bold text-uppercase brand-logo">
            <img src={eftwm} className={`logo ${scrolled ? 'logo-small' : ''}`} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto fw-semibold">
              <Nav.Link href="#inicio" className="mx-lg-2">INICIO</Nav.Link>
              <Nav.Link href="#nosotros" className="mx-lg-2">NOSOTROS</Nav.Link>
              <Nav.Link href="#actividades" className="mx-lg-2">ACTIVIDADES</Nav.Link>
              <Nav.Link href="#productos" className="mx-lg-2">PRODUCTOS</Nav.Link>
              <Nav.Link href="#clientes" className="mx-lg-2">CLIENTES</Nav.Link>
              <Nav.Link href="#contacto" className="mx-lg-2">CONTACTO</Nav.Link>
            </Nav>

            <Nav>
              <Nav.Link href="tel:5526201411" className="phone-link d-flex align-items-center">
                <Phone size={18} className="me-2" />
                <span className="fw-bold"><a href="tel:5526201411">(55) 2620 1411</a></span>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <section id="inicio" className="hero-relative" style={{ minHeight: '100vh', position: 'relative' }}>

        {/* Carrusel de Fondo (Automático) */}
        <Carousel
          fade
          controls={false}
          indicators={false}
          interval={5000}
          pause={false}
          className="hero-carousel-bg"
        >
          <Carousel.Item>
            <div className="carousel-img-overlay vh-100" style={{ backgroundImage: 'url("' + e05 + '")' }}></div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="carousel-img-overlay vh-100" style={{ backgroundImage: 'url("' + e01 + '")' }}></div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="carousel-img-overlay vh-100" style={{ backgroundImage: 'url("' + e02 + '")' }}></div>
          </Carousel.Item>
        </Carousel>

        <div className="hero-content-overlay d-flex align-items-center">
          <Container>
            <Row className="align-items-center mt-5 mt-lg-0">
              {/* LADO IZQUIERDO: Texto del PDF */}
              <Col lg={7} className="text-white mb-5 mb-lg-0 p-5">
                <div className="display-3 fw-bold mb-3 hero-title">
                  <div>COMPROMISO</div>
                  <div> <span className="text-primary-custom" >CALIDAD</span> </div>
                  <div>CONFIANZA</div>
                </div>
                <p className="lead fs-5">
                  Electricity For The World Mexico, cuenta con personal altamente calificado, con cursos y aprobación DC-3, lo que garantiza brindar a cada uno de nuestros clientes, asesoría, instalación y mantenimiento en cada una de las áreas del campo.
                </p>
              </Col>

              {/* LADO DERECHO: Formulario */}
              <Col lg={5}>
                <Card className="border-0 shadow-lg p-2 p-md-4"
                  style={{
                    borderRadius: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.2)', // Blanco con 0.5 de opacidad
                    backdropFilter: 'blur(5px)' // Opcional: añade un efecto de cristal esmerilado muy elegante
                  }}>
                  <Card.Body>
                    <h4 className="fw-bold mb-4 text-center hero-form">Contáctanos</h4>
                    <Form id="contactForm" onSubmit={handleOnClick}>
                      <Form.Group className="mb-3">
                        <Form.Control type="text" required name="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre completo" />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Control type="email" required value={email} name="email" onChange={(e) => setEmail(e.target.value)} placeholder="Correo electrónico" />
                      </Form.Group>
                      <Row>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control type="number" required value={phone} name="phone" onChange={(e) => setPhone(e.target.value)} placeholder="Teléfono" />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Form.Group className="mb-4">
                        <Form.Control as="textarea" required name="comments" value={comments} rows="3" className="textarea-style" onChange={(e) => setComments(e.target.value)} placeholder="¿En qué podemos ayudarte?" />
                      </Form.Group>
                      <div align="center">
                        <Button disabled={isActive} className="btn-custom-blue rounded-0 border-0 py-3 px-5 text-uppercase fw-bold" type="submit">
                          <Spinner
                            className={isActive ? '' : 'hide'}
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          {textBtn}
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <div className='us-bg' >
        <section id="nosotros" className="section-custom" style={{ paddingBottom: 0 }}>
          <div align="center">
            <div className='us-desc'>
              <Container>
                <h2 className="text-center mb-5 section-title">ACERCA DE NOSOTROS</h2>
                <Row>
                  <div align="center">
                    <div className='section-desc'>
                      <div className='mb-5' align="center"><b>Electricity For The World Mexico S de R.L. de C.V.</b>, es una empresa de capital 100 % Mexicano dedicada a la solución de las necesidades de sus clientes;  ofreciendo un apoyo eficiente para la culminación de  proyectos, ingenierías, mantenimientos  e instalaciones eléctricas obteniendo los resultados satisfactorios; comercialización de equipo eléctrico principalmente en sistemas eléctricos de baja y media tensión; calidad de la energía eléctrica; alumbrado, fuerza  y control.</div>
                      <Container>
                        <Row>
                          <Col md={6} lg={6}>
                            <div align="left">
                              <div className='us-title-card mb-3'> <CircleDot size={15} className='us-icon' style={{ backgroundColor: '#315ee5' }} /> &nbsp; Misión</div>
                              <div className='us-desc-card'>Ser un proveedor consistente cuyos productos, servicios y precios sean de la completa satisfacción del cliente.</div>
                            </div>
                          </Col>
                          <Col md={6} lg={6}>
                            <div>
                              <div className='us-title-card mb-3'> <Eye size={15} className='us-icon' style={{ backgroundColor: '#ecc102' }} /> &nbsp; Visión</div>
                              <div className='us-desc-card'>Somos una empresa dedicada a solucionar las necesidades de nuestros clientes con lo último en tecnología, comprometidos con el  Medio Ambiente y proyectos de energías limpias.</div>
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                    {/*<div>
                <Button className="btn-custom-blue rounded-0 border-0 py-3 px-5 text-uppercase fw-bold">
                  Conoce más sobre nosotros
                </Button>
              </div>*/}
                  </div>
                </Row>
              </Container>
            </div>
          </div>
        </section>

        <section id="actividades" className="section-custom">
          <Container>
            <Row className='align-items-center'>
              <Col xs={12} md={6} lg={6}>
                <Image
                  src={activities}
                  alt='Actividades'
                  className="custom-rounded-img img-fluid w-100"
                />
              </Col>
              <Col xs={12} md={6} lg={6}>
                <div align="right">
                  <h2 className="mb-5 text-center section-title">NUESTRAS ACTIVIDADES</h2>
                  <div align='center'>
                    <div className='section-desc'>
                      Monitoreo, análisis, diagnóstico y soluciones para la calidad de la energía eléctrica, proyectos eléctricos de media y baja tensión, líneas de distribución aéreas y subterráneas, ingenierías para solución del factor de potencia, sistemas de puesta a tierra, transformadores, alumbrado, subestaciones, tableros, reguladores de tensión, bancos de capacitores, filtros de armónicas, acondicionador de línea, restauradores, centro de control de motores (CCM),  plantas de emergencia y mantenimiento de equipo eléctrico.
                    </div>
                  </div>
                  <br />
                  {/*<div>
                  <Button className="btn-custom-blue rounded-0 border-0 py-3 px-5 text-uppercase fw-bold">
                    Conoce más sobre nosotros
                  </Button>
                </div>*/}
                </div>
              </Col>
            </Row>
            <Row>
              <Container className="my-5">
                <Carousel
                  activeIndex={index}
                  onSelect={handleSelect}
                  indicators={false}
                  controls={false}
                  interval={null}
                >
                  {groupedServices.map((group, idx) => (
                    <Carousel.Item key={idx}>
                      <Row>
                        {group.map((service, i) => (
                          <Col md={6} key={i} onClick={() => handleOpenModal(service)}>
                            <div className="service-card" style={{ backgroundImage: `url(${service.img})` }}>
                              <div className="service-overlay">
                                <h3 className="service-title">{service.title}</h3>
                                <div className="arrow-box">
                                  <ArrowRight size={24} color="black" />
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Carousel.Item>
                  ))}
                </Carousel>

                <div className="d-flex justify-content-center align-items-center mt-4">
                  <Button
                    className="btn-nav-carousel rounded-0 border-0 me-2"
                    onClick={() => setIndex(index === 0 ? groupedServices.length - 1 : index - 1)}
                  >
                    <ChevronLeft size={24} />
                  </Button>

                  {/* Indicador de posición (opcional) */}
                  <span className="mx-3 fw-bold text-muted">
                    {index + 1} / {groupedServices.length}
                  </span>

                  <Button
                    className="btn-nav-carousel rounded-0 border-0 ms-2"
                    onClick={() => setIndex(index === groupedServices.length - 1 ? 0 : index + 1)}
                  >
                    <ChevronRight size={24} />
                  </Button>
                </div>

              </Container>
            </Row>
          </Container>
        </section>
      </div>

      <section id="productos" className="section-custom services-bg">
        <Container align="center">
          <div className="text-uppercase text-center section-title">
            PRODUCTOS
          </div>

          <Nav
            className="justify-content-center custom-tabs-row"
            activeKey={activeCat}
            onSelect={(selectedKey) => setActiveCat(selectedKey)}
          >
            <Nav.Item key={index} className="flex-fill flex-md-grow-0">
              <Nav.Link eventKey={'accesorios'} className="text-uppercase fw-bold rounded-0 text-center" >
                Accesorios Cooper Eaton
              </Nav.Link>
            </Nav.Item>
            <Nav.Item key={index} className="flex-fill flex-md-grow-0">
              <Nav.Link eventKey={'transformadores'} className="text-uppercase fw-bold rounded-0 text-center" >
                Transformadores
              </Nav.Link>
            </Nav.Item>
            <Nav.Item key={index} className="flex-fill flex-md-grow-0">
              <Nav.Link eventKey={'capacitores'} className="text-uppercase fw-bold rounded-0 text-center" >
                Bancos de Capacitores
              </Nav.Link>
            </Nav.Item>
            <Nav.Item key={index} className="flex-fill flex-md-grow-0">
              <Nav.Link eventKey={'filtros'} className="text-uppercase fw-bold rounded-0 text-center" >
                Filtros de Armónicas
              </Nav.Link>
            </Nav.Item>
            <Nav.Item key={index} className="flex-fill flex-md-grow-0">
              <Nav.Link eventKey={'supresores'} className="text-uppercase fw-bold rounded-0 text-center" >
                Supresores de Transitorios
              </Nav.Link>
            </Nav.Item>

          </Nav>

          {activeCat === 'accesorios' && <>
            <div className="us-title-card" style={{ marginTop: '30px', marginBottom: '30px', textAlign: "center" }}>Accesorios Cooper Eaton</div>

            <Row className="g-4">
              {PRODUCTS.map(product => (
                <Col md={4} xs={12}>
                  <ProductCard
                    producto={product} handleDetailModal={handleDetailModal}
                  />
                </Col>
              ))}
            </Row>
          </>}

        </Container>
      </section>

      <section id="clientes" className="section-custom">
        <Container align="center">
          <div className="text-uppercase text-center section-title" style={{ marginBottom: '50px' }}>
            NUESTROS CLIENTES
          </div>

          <Marquee
            gradient={true}
            gradientColor={[248, 249, 250]} // Color del fondo (bg-light)
            speed={50}
            pauseOnHover={false}
            autoFill={true}
          >
            {clientes.map((logo, index) => (
              <div key={index} className="d-flex align-items-center justify-content-center" style={{ margin: '0 50px' }}>
                <img
                  src={logo.url}
                  alt={logo.name}
                  className="logo-filter marquee-logo-large"
                />
              </div>
            ))}
          </Marquee>
        </Container>
      </section>

      <section className="parallax-container d-flex align-items-center justify-content-center"
        style={{ backgroundImage: `url(${frase})` }}>
        <div className="parallax-overlay"></div>

        <Container className="position-relative z-index-2">
          <Row className="justify-content-center">
            <Col md={8} className="text-center">
              <div className="parallax-text fw-bold">
                “Dedicados a la solución de las necesidades de nuestros clientes.”
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-custom">
        <Container align="center">
          <div className="text-center text-uppercase section-title" style={{ marginBottom: '50px' }}>
            SOCIOS COMERCIALES
          </div>

          <Marquee
            gradient={true}
            gradientColor={[248, 249, 250]} // Color del fondo (bg-light)
            speed={50}
            pauseOnHover={false}
            autoFill={true}
            direction="right"
          >
            {logos.map((logo, index) => (
              <div key={index} className="d-flex align-items-center justify-content-center" style={{ margin: '0 50px' }}>
                <img
                  src={logo.url}
                  alt={logo.name}
                  className="logo-filter marquee-logo-large"
                />
              </div>
            ))}
          </Marquee>
        </Container>
      </section>

      <section id="contacto" className="section-custom contacto-bg">
        <div className='contacto-title' align="center">CONTACTO</div>

        <div align="center">
          <div className='contacto-desc'>Ingresa tus datos de contacto y uno de nuestros agentes se comunicará contigo a la brevedad</div>
          <div className='contacto-desc mb-2'>Tambien puedes comunicarte directamente al <a href="tel:5526201411" target='_blank' rel="noreferrer"><span style={{ color: '#ffcc00' }}>(55) 2620 1411</span></a></div>
        </div>

        <div align="center">
          <div className='contacto-form-container'>
            <Container className="py-5">
              <Form id="contactForm" onSubmit={handleOnClick}>
                <Row>
                  <Col md={12} className="mb-4">
                    <Form.Group>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Nombre completo"
                        className="input-dark rounded-0 border-0"
                        name="name" value={name} onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6} className="mb-4">
                    <Form.Group>
                      <Form.Control
                        required
                        type="tel"
                        placeholder="Teléfono"
                        className="input-dark rounded-0 border-0"
                        value={phone} name="phone" onChange={(e) => setPhone(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-4">
                    <Form.Group>
                      <Form.Control
                        required
                        type="email"
                        placeholder="Correo Electrónico"
                        className="input-dark rounded-0 border-0"
                        value={email} name="email" onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={12} className="mb-4">
                    <Form.Group>
                      <Form.Control
                        required
                        as="textarea"
                        rows={4}
                        name="comments" value={comments} onChange={(e) => setComments(e.target.value)}
                        placeholder="Mensaje"
                        className="input-dark rounded-0 border-0"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex justify-content-center">
                  <Button disabled={isActive} className="btn-custom-blue rounded-0 border-0 py-3 px-5 text-uppercase fw-bold" type="submit">
                    <Spinner
                      className={isActive ? '' : 'hide'}
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {textBtn}
                  </Button>
                </div>
              </Form>
            </Container>
          </div>
        </div>
      </section>

      {/*<section className="parallax-container d-flex align-items-center justify-content-center"
        style={{ backgroundImage: `url(https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=1600)` }}>
        <div className="parallax-overlay-blue"></div>

        <Container className="position-relative z-index-2">
          <Row className="justify-content-center">
            <Col sx={12} md={8} lg={8}></Col>
            <Col sx={12} md={4} lg={4} align="right">
              <div className="contacto-parallax-title fw-bold">
                ELECTRICITY FOR THE WORLD MEXICO S. DE R.L. DE C.V.
              </div>
              <br />
              <div className="contacto-parallax-desc">
                Calle Altun-Ha, Manzana 379, Lote 6 Colonia el Tikal,
                <br />
                Cuautitlán Izcalli, Estado de México, C.P. 54765
              </div>
            </Col>
          </Row>
        </Container>
      </section>*/}

      <CookieConsent />

      <footer className="pt-5 pb-3 footer-bg">
        <Container>
          <Row className='mb-3'>
            <Col md={12}>
              <div align="center">
                <div><img src={eftwm} className='logo' /></div>
                <br />
                <span align="center"><PhoneCall size={18} /> <a href="tel:5558722891" target='_blank' rel="noreferrer"> 01(55) 5872-2891 </a></span> &nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                <span align="center"><Mail size={18} /> <a href='mailto:edi.cano@eicg.mx' target='_blank' rel="noreferrer">edi.cano@eicg.mx</a> </span>
              </div>
            </Col>
          </Row>
          <Row>
            <hr />
          </Row>
          <Container>
            <Row>
              <Col>
                <Row className='mb-3'>
                  <div className=""><b>© 2026 ELECTRICITY FOR THE WORLD MEXICO S. DE R.L. DE CV.</b></div>
                  <div className='footer-small-text'><MapPin size={13} /> Calle Altun-Ha, Manzana 379, Lote 6 Colonia el Tikal, Cuautitlán Izcalli, Estado de México, C.P. 54765 </div>
                </Row>
                <Row className='mb-3'>
                  <Col xs={6} md={3} lg={3}>
                    <div className='text-center footer-small-text'><a href="tel:5558722891" target='_blank' rel="noreferrer">01(55) 5872 - 2891</a></div>
                  </Col>
                  <Col xs={6} md={3} lg={3}>
                    <div className='text-center footer-small-text'><a href="tel:5558715449" target='_blank' rel="noreferrer">01(55) 5871 - 5449</a></div>
                  </Col>
                  <Col xs={6} md={3} lg={3}>
                    <div className='text-center footer-small-text'><a href="tel:5558706071" target='_blank' rel="noreferrer">01(55) 5870 - 6071</a></div>
                  </Col>
                  <Col xs={6} md={3} lg={3}>
                    <div className='text-center footer-small-text'><a href="tel:5526201411" target='_blank' rel="noreferrer">01(55) 2620 - 1411</a></div>
                  </Col>
                </Row>
              </Col>
              <Col>
                <div align='right'>
                  <div className='footer-title'>REGISTROS</div>
                  <img src={bm} height={35} />&nbsp;&nbsp;&nbsp;&nbsp;
                  <img src={repse} height={35} />
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </footer>

    </div >
  );
}

export default App;
